import locationDB from "../helper/db";

export const getAuthToken = () => {
  try {
    return localStorage.getItem("act_token")
      ? `${localStorage.getItem("act_token")}`
      : null;
  } catch (error) {
    console.log("🚀 ~ getAuthToken ~ error:", error);
  }
};

export const getDufresneStationList = async () => {
  try {
    return await locationDB.getData("dufresneStationList");
  } catch (error) {
    console.error("Error fetching station list:", error);
    throw error;
  }
};

export const getStationList = async () => {
  try {
    const { data } = (await locationDB.getData("allStationList")) || {};
    return data;
  } catch (error) {
    console.error("Error fetching station list:", error);
    throw error;
  }
};
